import { configurarSelect } from './setupRange.js';
import { actualizarResumen } from './renderResumen.js';
import { fetchCuotas } from './fetchData.js';
import { generarMensajeWhatsApp, abrirWhatsApp } from './whatsapp.js';

document.addEventListener("DOMContentLoaded", async () => {

    const cuotasValidas = [3, 6, 12, 24, 36];

    const simulator = document.getElementById("credit-simulator");
    if (!simulator) {
        return;
    }

    const slug = simulator.dataset.slug;
    const hasModelos = simulator.dataset.hasModelos === "1";


    const quotaSelect = document.getElementById("select-quota");
    const selectModel = document.getElementById("select-model");

    const elements = {
        label: document.getElementById("quota-label"),
        total: document.getElementById("value-total"),
        month: document.getElementById("value-month"),
        clp: document.getElementById("value-clp"),
    };

    if (!quotaSelect) {
        return;
    }

    const result = await fetchCuotas(slug);

    if (!result) {
        console.error("❌ fetchCuotas falló");
        return;
    }

    const { valorUF, cuotasData } = result;

    const doUpdate = () => {
        actualizarResumen(cuotasData, valorUF, cuotasValidas, quotaSelect, elements);
    };

    if (!hasModelos) {
        doUpdate(); // Primera carga

        quotaSelect.addEventListener("change", (e) => {
            doUpdate();
        });

    } else if (selectModel) {
        quotaSelect.disabled = true;

        selectModel.addEventListener("change", () => {
            console.log("🏠 Modelo seleccionado:", selectModel.value);
            const modeloId = selectModel.value;
            const modelo = cuotasData.find(m => m.id === modeloId);

            if (!modelo || !modelo.cuotas) {
                console.warn("⚠️ Modelo sin cuotas");
                return;
            }

            quotaSelect.disabled = false;

            if (quotaSelect.boundCallback) {
                quotaSelect.removeEventListener("change", quotaSelect.boundCallback);
            }

            quotaSelect.boundCallback = () => {
                console.log("🎛️ SELECT modelo cambió a:", quotaSelect.value);
                actualizarResumen(modelo.cuotas, valorUF, cuotasValidas, quotaSelect, elements);
            };

            actualizarResumen(modelo.cuotas, valorUF, cuotasValidas, quotaSelect, elements);
            quotaSelect.addEventListener("change", quotaSelect.boundCallback);
        });
    }

    const dialog = document.getElementById("email-dialog");
    const openDialogBtn = document.getElementById("open-email-dialog");
    const closeDialogBtn = document.getElementById("close-email-dialog");
    const feedback = document.getElementById("email-feedback");

    openDialogBtn?.addEventListener("click", () => {
        dialog.showModal();
    });

    closeDialogBtn?.addEventListener("click", () => {
        dialog.close();
        clearModal();
    });

    document.getElementById("email-form")?.addEventListener("submit", function (e) {
        e.preventDefault();

        const form = e.target;
        const payload = {
            email: form.email.value,
            slug: simulator.dataset.slug,
        };

        if (selectModel && selectModel.value) {
            payload.modelo_id = selectModel.value;
        }

        const submitBtn = document.getElementById("email-submit-btn");
        const originalBtnText = submitBtn.textContent;

        submitBtn.disabled = true;
        submitBtn.textContent = "Procesando...";

        fetch('/simulator/my-simulator', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-CSRF-TOKEN': document.head.querySelector("[name=csrf-token]").content
            },
            body: JSON.stringify(payload)
        })
            .then(res => res.json())
            .then(res => {
                if (res.success) {
                    feedback.textContent = "✅ Simulación enviada correctamente.";
                    feedback.classList.remove("hidden");
                    feedback.classList.add("text-green-600");

                    setTimeout(() => {
                        dialog.close();
                        clearModal();
                    }, 2000);
                } else {
                    feedback.textContent = "❌ Error al enviar el correo.";
                    feedback.classList.remove("hidden");
                    feedback.classList.add("text-red-600");
                }
            })
            .catch(() => {
                feedback.textContent = "❌ Error de conexión.";
                feedback.classList.remove("hidden");
                feedback.classList.add("text-red-600");
            })
            .finally(() => {
                submitBtn.disabled = false;
                submitBtn.textContent = originalBtnText;
            });
    });

    // ===== BOTÓN SIMULAR (deshabilitado) =====
    if (false) {
        const btnSimular = document.getElementById("open-email-dialog");

        if (!hasModelos) {
            btnSimular.disabled = false;
        } else {
            btnSimular.disabled = true;

            selectModel.addEventListener("change", () => {
                if (selectModel.value) {
                    btnSimular.disabled = false;
                }
            });

            btnSimular.addEventListener("click", (e) => {
                if (!selectModel.value) {
                    e.preventDefault();
                    alert("Por favor, selecciona un modelo antes de enviar la simulación.");
                }
            });
        }
    }

    // ===== WHATSAPP =====
    const btnWhatsApp = document.getElementById("btn-whatsapp-contact");

    btnWhatsApp?.addEventListener("click", () => {
        let modeloTitle = document.querySelector('#hero > .main > .container-info > .header > .title');
        modeloTitle = modeloTitle?.textContent?.trim().replace(/\s+/g, ' ') || '';
        let modeloLabel = slug;

        const index = parseInt(quotaSelect.value);
        const cuotasElegidas = cuotasValidas[index];
        let infoCuota = null;

        if (!valorUF || !cuotasData || !cuotasElegidas) return;

        if (!hasModelos) {
            infoCuota = cuotasData[cuotasElegidas];
        } else if (selectModel?.value) {
            const modelo = cuotasData.find(m => m.id === selectModel.value);
            if (!modelo) return;

            modeloLabel = selectModel.options[selectModel.selectedIndex]?.text ?? modelo.id;
            modeloLabel = modeloTitle + ' ' + modeloLabel;
            infoCuota = modelo.cuotas?.[cuotasElegidas];
        } else {
            alert("Por favor, selecciona un modelo antes de continuar.");
            return;
        }

        if (!infoCuota) {
            alert("No hay información disponible para esa cantidad de cuotas.");
            return;
        }

        const mensaje = generarMensajeWhatsApp({
            modeloLabel,
            cuotasElegidas,
            infoCuota,
            valorUF
        });

        const numero = "56964796404";
        abrirWhatsApp(numero, mensaje);
    });

});
